import { render, staticRenderFns } from "./RateReceivableTableHead.vue?vue&type=template&id=055ecb4c&"
import script from "./RateReceivableTableHead.vue?vue&type=script&lang=js&"
export * from "./RateReceivableTableHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports